// See https://html.spec.whatwg.org/multipage/server-sent-events.html#parsing-an-event-stream

export interface SseMessage {
  type: string
  id: string
  data: string
}

// const parseMessages = (raw: string): SseMessage[] =>
//   raw
//     .split(/\r\n|\r|\n/)
//     .filter((line) => line.length > 0 || line[0] === `:`) // ignore comments
//     .map((line) => {
//       const [key, value] = line.split(`:`)
//       return {
//         type: key,
//         id: value,
//         data: value,
//       }
//     })

export class SseParser {
  public eventType: string | undefined
  public eventId: string | undefined
  public eventData: string | undefined
  public pendingLines: string[] = []
  public pendingText = ``

  public lastEventId: string | undefined

  // public parse(raw: string): SseMessage[] {
  //   const messages = parseMessages(raw)
  //   this.eventId = messages[0].id
  //   // return
  // }

  private clearEvent(): void {
    this.eventType = undefined
    this.eventId = undefined
    this.eventData = undefined
  }

  public handleChunk(chunk: string): SseMessage[] {
    this.pendingText += chunk
    const lines = this.pendingText.split(/\r\n|\r|\n/)
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    this.pendingText = lines.pop()!
    this.pendingLines.push(...lines)

    const messages: SseMessage[] = []

    while (this.pendingLines.length > 0) {
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      const line = this.pendingLines.shift()!
      // a blank line in the response from the server indicates
      //the end of the prior event
      if (!line.trim()) {
        if (!this.eventType) {
          throw Error(`invalid SSE message: missing type`)
        }
        if (!this.eventId) {
          throw Error(`invalid SSE message: missing ID`)
        }
        if (!this.eventData) {
          throw Error(`invalid SSE message: missing data`)
        }
        this.lastEventId = this.eventId
        messages.push({
          type: this.eventType,
          id: this.eventId,
          data: JSON.parse(this.eventData),
        })
        this.clearEvent()
        continue
      }

      // ignore comment lines starting with colon
      if (line[0] === `:`) {
        continue
      }

      const m = /^(event|id|data): ?(.+?)$/.exec(line)
      if (!m) {
        throw Error(`invalid SSE line: ` + line)
      }
      switch (m[1]) {
        case `event`:
          this.eventType = m[2]
          break
        case `id`:
          this.eventId = m[2]
          break
        case `data`:
          if (this.eventData) {
            this.eventData += `\n` + m[2]
          } else {
            this.eventData = m[2]
          }
          break
        default:
          throw Error(`invalid SSE line: ` + line)
      }
    }

    return messages
  }
}
